let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eVYW1")).then(() => parcelRequire('11LZV'));